import { render } from "./goodsFloor.vue?vue&type=template&id=70fd8d65&scoped=true"
import script from "./goodsFloor.vue?vue&type=script&lang=js"
export * from "./goodsFloor.vue?vue&type=script&lang=js"

import "./goodsFloor.vue?vue&type=style&index=0&id=70fd8d65&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fd8d65"]])

export default __exports__